import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isAdminUser } from "../../admin/navigation/adminNavigation";

const AdminProtected = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const location = useLocation();

  if (isAdminUser(authState)) {
    return children;
  }

  return (
    <Navigate
      to="/admin-login"
      replace
      state={{ from: `${location.pathname}${location.search}${location.hash}` }}
    />
  );
};

export default AdminProtected;
